import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsIndexedText {
    export const componentId = 'indexed-text';

    export interface IIndexedTextItem {
        title?: string;
        content?: string;
    }

    export interface IIndexedTextData extends NICmsContentComponent.IData {
        items?: IIndexedTextItem[];
        menuTitleFont?: string;
        contentTitleFont?: string;
        contentFont?: string;
    }
}

@ICmsComponent<CmsIndexedTextComponent>({
    id: NCmsIndexedText.componentId,
    name: 'Indexed Text',
    tags: ['questions', 'points', 'list', 'text'],
    isAdvanced: true,
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'menuTitleFont',
            type: NICmsContentField.EFieldType.choice,
            title: 'Menu Font Size',
            options: TextStyleOptions,
            default: 'h2'
        },
        <NICmsContentField.IChoiceField>{
            key: 'contentTitleFont',
            type: NICmsContentField.EFieldType.choice,
            title: 'Content Title Font Size',
            options: TextStyleOptions,
            default: 'h6'
        },
        <NICmsContentField.IChoiceField>{
            key: 'contentFont',
            type: NICmsContentField.EFieldType.choice,
            title: 'Content Font Size',
            options: TextStyleOptions,
            default: 'q1'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Item',
            itemName: 'item',
            itemNameField: 'title',
            defaultSize: 2,
            complex: true,
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title'
                },
                {
                    type: NICmsContentField.EFieldType.textarea,
                    key: 'content',
                    title: 'content'
                }
            ],
            default: [
                { title: 'First title', content: 'First content' },
                { title: 'Second title', content: 'Second content' }
            ]
        }
    ]
})
@Component({
    selector: 'page-component-indexed-text',
    templateUrl: './cms-indexed-text.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsIndexedTextComponent extends UiComponent implements NICmsContentComponent.IComponent {
    constructor(
        private elementRef: ElementRef,
        private scrollToService: ScrollToService
    ) {
        super();
    }

    @ICmsContent({
        type: 'component'
    })
    component?: NCmsIndexedText.IIndexedTextData;

    scrollToIndex(i: number) {
        const element = this.elementRef.nativeElement.querySelector('#item_' + i);
        if (element) {
            this.scrollToService.scrollTo(element, { offset: 120 });
        }
    }
}
